import { Dispatch, SetStateAction } from "react";
import { GanttStatic } from "./Gantt/dhtmlxgantt";

export const GANTT_VIEW_TYPE = {
  PLANNED: "Planned",
  ACTUAL: "Actual",
  FORECAST: "Forecast",
  PLANNED_AGAINST_ACTUAL: "Planned Against Actual",
  PLANNED_AGAINST_ACTUAL_PERCENTAGE: "Planned Against Actual Percentage Based",
} as const;

export type GanttViewType = (typeof GANTT_VIEW_TYPE)[keyof typeof GANTT_VIEW_TYPE];

export interface GanttProps {
  refreshGanttContract?: boolean;
  setRefreshGanttContract?: (value: boolean) => void;
  activeTab?: string;
  viewType?: GanttViewType;
  changeOrderState?: any;
  scheduleId?: string;
  spaceId?: string;
  projectId?: string;
  fileVersionId?: string;
  contractDetails?: any;
  contractId?: string;
  attachTaskModalState?: any;
  setDisableTabs?: (value: boolean) => void;
  showFullScreen?: boolean;
  setShowFullScreen?: (value: boolean) => void;
  fetchVersions?: any;
  scheduleVersionId?: string;
}

export interface ResourceProps {
  scheduleId?: string;
  spaceId?: string;
  projectId?: string;
  fileVersionId?: string;
  showFullScreen?: boolean;
  setShowFullScreen?: (value: boolean) => void;
  fetchVersions?: any;
  scheduleVersionId?: string;
}

export interface ToolbarProps {
  contractId?: string;
  scheduleId?: string;
  projectId?: string;
  spaceId?: string;
  enableImportButton: boolean;
  currentSelectedTask: any;
  setShowActivityInformationModal: (value: boolean) => void;
  inlineEditingEnabled: boolean;
  contractDetails: any;
  changeOrderState: any;
  setShowProgressModal: (value: boolean) => void;
  setCurrentSelectedTask: (value: any) => void;
  setShowShimmer: (value: boolean) => void;
  setShowWarning: (value: any) => void;
  setShowBoqModal: (value: boolean) => void;
  attachTaskModalState: (value: string, value1: boolean) => void;
  taskIdAndPredecessorMapper: Record<string, any>;
  ganttConfig: any;
  setRerenderGantt: (value: boolean) => void;
  showDeleteActivityModal: boolean;
  setShowDeleteActivityModal: (value: boolean) => void;
  scheduleVersionId?: string;
  timezone: string;
  refreshParentSummaries: (
    taskId: string,
  ) => Array<{ id: string; progress?: number; plannedStartDate?: Date | null; plannedEndDate?: Date | null }>;
  saveBatchSummaryUpdates: (
    updates: Array<{ id: string; progress?: number; plannedStartDate?: Date | null; plannedEndDate?: Date | null }>,
  ) => Promise<void>;
  setSkipAfterTaskUpdate: (value: boolean) => void;
  isDeletingTask: React.MutableRefObject<boolean>;
  isGrouped?: boolean;
}

export interface ActivityInformationModalProps {
  showActivityInformationModal: boolean;
  loadingActivity?: boolean;
  setLoadingActivity: (value: boolean) => void;
  setShowActivityInformationModal: (value: boolean) => void;
  currentSelectedTask: any;
  setCurrentSelectedTask: (value: any) => void;
  ganttConfig: any;
  gantt: GanttStatic;
  taskCounter: any;
  scheduleId: string;
  fileVersionId?: string;
  spaceId?: string;
  projectId?: string;
}

export interface UpdatesModalProps {
  gantt: GanttStatic;
  scheduleId?: string;
  currentSelectedTask: any;
  setCurrentSelectedTask: (value: any) => void;
  setShowProgressModal: Dispatch<SetStateAction<boolean>>;
  showProgressModal: boolean;
  loadingProgressModal?: boolean;
  setLoadingProgressModal: Dispatch<SetStateAction<boolean>>;
  ganttConfig?: any;
}

export interface SimulationProps {
  activeTab: string;
  ganttDataAvailable: any;
  viewType: GanttViewType;
  setDisableTabs: (value: boolean) => void;
}

export interface GanttQueueItem {
  entity: string;
  action: string;
  data: any;
}

export interface DateSliderProps {
  scheduleStartDate: number;
  scheduleEndDate: number;
  scheduleActualEndDate: number;
  scheduleActualStartDate: number;
  viewType: GanttViewType;
  scheduleId: string;
  onColumnChooserClick: () => void;
}

export interface DependencyProps {
  currentTab: string;
  gantt: GanttStatic;
  currentSelectedTask: any;
  deletedLinks: any;
  setDeletedLinks: any;
  dependencyAddEditData: any;
  setDependencyAddEditData: any;
  hoursPerDay: number;
}

export interface ResourceGanttProps {
  deletedResources: any;
  setDeletedResources: (value: any) => void;
  resourceAddEditData: any;
  setResourceAddEditData: (value: any) => void;
  gantt: GanttStatic;
}
